import { FC } from 'react';
import { Avatar } from '@mui/material';
import { IVanHost } from 'src/models/IVan';

interface IProps {
  host: IVanHost;
}

const VanHost: FC<IProps> = ({ host }) => {
  const { photo, first_name, last_name } = host;
  return (
    <div className='van__order__host'>
      {photo ? (
        <img src={photo} alt='user photo' loading='lazy' className='user-photo' />
      ) : (
        <Avatar src='/broken-image.jpg' />
      )}
      <div className='van__order__host__container'>
        <p className='van__order__host__title'>Hosted by:</p>
        <p className='van__order__host__name'>
          {`${first_name.split(' ')[0]} ${last_name.slice(0, 1)}.`}
        </p>
      </div>
    </div>
  );
};
export default VanHost;
